var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRestoreZoom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 26,
    width: 26,
    y: -1,
    x: -1
  }), /*#__PURE__*/React.createElement("g", {
    display: "none",
    overflow: "visible",
    y: 0,
    x: 0,
    height: "100%",
    width: "100%",
    id: "canvasGrid"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#gridpattern)",
    strokeWidth: 0,
    y: 0,
    x: 0,
    height: "100%",
    width: "100%"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#000000",
    ry: 8.27161,
    rx: 8.27161,
    id: "svg_9",
    cy: 9.84375,
    cx: 9.97068,
    strokeOpacity: "null",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#000000",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    id: "svg_10",
    y2: 24.25616,
    x2: 24.13309,
    y1: 15.51659,
    x1: 15.39352,
    fillOpacity: "null",
    strokeOpacity: "null",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    shapeRendering: "crispEdges",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 12,
    id: "svg_13",
    y: 13.90527,
    x: 6.09375,
    fillOpacity: "null",
    strokeOpacity: "null",
    stroke: "#000000",
    fill: "#000000"
  }, "1"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestoreZoom);
export default __webpack_public_path__ + "static/media/restoreZoom.50f15246044cee20f9a0b70ffffdad99.svg";
export { ForwardRef as ReactComponent };